const SESSION_EXPIRES_AT_COOKIE = 'session_expires_at';

/**
 * Момент истечения сессии, сообщённый бэкендом, в миллисекундах эпохи.
 * `null` — момент не сообщён: сессии нет либо она уже завершена.
 */
export const readSessionExpiresAt = (): number | null => {
  const prefix = `${SESSION_EXPIRES_AT_COOKIE}=`;
  const raw = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(prefix))
    ?.slice(prefix.length);

  if (!raw) {
    return null;
  }

  const expiresAt = new Date(decodeURIComponent(raw)).getTime();

  return Number.isNaN(expiresAt) ? null : expiresAt;
};
